import React from "react"

export default function FilterSpace() {
	const spaceStyle = {
		flexGrow: 1,
	}

	return <div style={spaceStyle} />
}
